import IMask from 'imask';

export default {
  mounted() {
    IMask(
      this.el, 
      { 
        mask: [
          { mask: '+{92} 000 0000000', startsWith: '9', country: 'Pakistan' }, 
          { mask: '+{61} 0000 000 000', startsWith: '6', country: 'Australia' },
          { mask: '+{1} (000) 000-0000', startsWith: '', country: 'US' },  // Default US format
        ],
        dispatch: function (appended, dynamicMasked) {
          var number = (dynamicMasked.value + appended).replace(/\D/g, '');

          // First check for specific country codes
          const specificCountry = dynamicMasked.compiledMasks.find(function (m) {
            return m.startsWith && number.indexOf(m.startsWith) === 0;
          });
          
          // If no specific country code found, return the default US mask
          return specificCountry || dynamicMasked.compiledMasks[2];
        } 
      }
    );
  },
};